import { Component, OnInit } from '@angular/core';
import {ClientService} from '../../shared/services/client.service';
import {AuthService} from '../../login/services/auth.service';
import { Assignment } from 'app/shared/models/Assignment';
import { ManagedClient } from 'app/shared/models/managed-client';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  public loadingAssessments: boolean;

  private _client:ManagedClient;
  private _assignments:Assignment[];

  constructor(private authService:AuthService
  ,private clientService:ClientService) { 
    this._assignments = [];
    this.loadingAssessments = true;
  }

  ngOnInit() {
    let clientOffset = 0; // start at 0 and retrieve up to 200 tests, which should be more than enough for an individual client assignment.
    let clientTestsLimit = 200; // retrieve as many of the tests as the client has as possible, default is 10 which we need more than that.
    this.authService.getCurrentClient().then((client) => {
      
      if (client) {
        this._client = client;
        this._assignments = client.assignments;
      }
      else {
        console.error(" no client found, cannot load assessments");
      }
      this.loadingAssessments = false;
    })
    .catch((error) => {
      this.loadingAssessments = false;
      console.log(error);
      // TODO: stephen need to display an error if there is nothing here.
    })
  }
  
  get assessmentsStarted() {
    
    return this._client && this._client.hasStartedAssignments();
  }

  get hasAssessments() {
    return this._client && !this._client.hasNoAssignments();
  }
  get assessmentsCompleted() {
    return this._client && this._client.hasFinishedAllAssignments();
  }

  get assignments() : Assignment[] {
    if (!this._client) {
      return [];
    }
    return this._client.assignments;
  }

  public getNextTest() : number {
    let nextAssignment = this._client.getNextAssignmentItemToComplete();
    if (!nextAssignment) {
      console.error("System error, client get next assignment returned null");
    }
    return nextAssignment ? nextAssignment.Id : null;
  }
}


// WEBPACK FOOTER //
// ./src/app/assessments/dashboard/dashboard.component.ts